// Centralised image registry — swap a single ID here and it updates
// everywhere it's used. Verified Unsplash photo IDs only (HTTP 200 checked).
//
// Image direction:
//   - empowering, lifestyle, modern, diverse
//   - support workers assisting naturally — not clinical
//   - young & middle-aged NDIS participants
//   - real-estate-style modern home interiors
//   - community participation, cooking, outdoors
// Avoid: hospital beds, aged-care, retirement-home, clinical close-ups.

const u = (id, w = 1600, q = 85) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&w=${w}&q=${q}`;

export const IMG = {
  // Hero — uses real Alpha home photography for unmistakable "modern,
  // premium, NDIS lifestyle" framing (no aged-care or clinical risk).
  heroLifestyle: "/homes/aintree/5.jpg",            // open-plan modern living
  heroHomes: "/homes/coburg/1.jpg",                 // luxury real estate
  heroIntake: u("1532938911079-1b06ac7ceec7", 2200, 85), // professional desk

  // Service tiles — modern interiors + warm support
  silTile: u("1600585154526-990dced4db0d", 1200, 85),
  sdaTile: u("1600566753190-17f0baa2a6c3", 1200, 85),
  communityNursingTile: u("1604881991720-f91add269bed", 1200, 85),
  supportCoordinationTile: u("1573497019418-b400bb3ab074", 1200, 85),
  communityParticipationTile: u("1511632765486-a01980e01a18", 1200, 85),
  dailyLivingTile: u("1558618666-fcd25c85cd64", 1200, 85),

  // For-Participants — real Alpha master bedroom (warm, lifestyle, premium)
  forParticipantsHero: "/homes/aintree/7.jpg",

  // For-Coordinators / referral — diverse colleague handshake (trust)
  coordinatorHero: u("1521791136064-7986c2920216", 1400, 85),

  // About — warm team / professional collaboration
  teamLeadership: u("1494790108377-be9c29b29330", 800, 80),
  teamOperations: u("1573496359142-b8d87734a5a2", 800, 80),
  teamClinical: u("1521791136064-7986c2920216", 800, 80),
  teamHousing: u("1500648767791-00dcc994a43e", 800, 80),

  // Generic poster fallback
  videoPoster: "/homes/coburg/4.jpg",
};

export default IMG;
